




























/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";

import axios from "axios";
import { IIssueService } from "../../../BusinessServices/issue";
import { IssueModel, BlobReplaceDTO, IssueViewerConfigDTO } from "../../../Generated/ParticaAPI";
import { IIssueConversionService } from "../../../BusinessServices/issueconversion";
import IssueViewerConfigForm from "../../../Ui-Components/Issue/IssueViewerConfig.vue";


@Component(
	{
		name: "IssueViewerConfiguration",
		components: {
			ButtonList,
			ParticaCard,
			ParticaView,
			IssueViewerConfigForm
		}
	})
export default class IssueViewerConfiguration extends ParticaIssueBase {
	@Prop() private id: number;
	private issueService: IIssueService;
	private issue: IssueModel = new IssueModel();
	private issueViewerConfig: IssueViewerConfigDTO = new IssueViewerConfigDTO();

	private buttons: ButtonConfig[] = [
		{ label: "Save", action: eParticaAction.ISSUE_SAVE_VIEWERCONFIG, type: ButtonType.OK } as ButtonConfig,
		{ label: "Format JSON", action: eParticaAction.WEBSITE_VIEWER_CONFIG_FORMAT_JSON, type: ButtonType.Normal } as ButtonConfig,


	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {

				case eParticaAction.ISSUE_SAVE_VIEWERCONFIG: {
					this.issueViewerConfig.issueId = this.id;
					this.issueViewerConfig.content = JSON.stringify(JSON.parse(this.issueViewerConfig.content as string));
					this.issueViewerConfig = await this.issueService.SaveViewerConfig(this.issueViewerConfig);
					await this.init();
					this.ShowSnackbar("Viewer Config for issue saved.");
					break;
				}
				case eParticaAction.WEBSITE_VIEWER_CONFIG_FORMAT_JSON: {
					this.issueViewerConfig.content = JSON.stringify(JSON.parse(this.issueViewerConfig.content as string), null, 2);
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Issue Viewer Config JSON";
		await this.init();
		await this.getIssueNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			this.issueService = this.particaServices.getIssueService();
			this.issue = await this.issueService.getIssue(this.id);
			const loaded = await this.issueService.LoadViewerConfig(this.id);
			if (loaded === null) {
				this.ShowSnackbar("There is no folio for this issue. Click 'SAVE' to store this generated one.");
			} else {
				this.issueViewerConfig = loaded;
				this.issueViewerConfig.content = JSON.stringify(JSON.parse(this.issueViewerConfig.content as string), null, 2);
			}
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
